import { Injectable } from '@angular/core';
import { ParametersDataApiService } from 'src/app/store/parameters-data/parameters-data.api.service';
import {
  ParameterData,
  ParametersDataResponseRequest,
} from 'src/app/pages/admin-manager/parameters/models/parameters.model';
import { defer, Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ChatbotAccessService {
  readonly enabled$: Observable<boolean> = defer(() => {
    const params: ParametersDataResponseRequest[] = [
      {
        parameterCode: 'CHATBOT_ENABLED',
        parameterScopeTypeId: 5,
        scopeId: null,
      },
    ];

    return this.parametersDataApi.getParametersData(params);
  }).pipe(
    take(1),
    map((response) => {
      const parameters: unknown = JSON.parse(response);
      if (!Array.isArray(parameters)) {
        throw new Error('Invalid CHATBOT_ENABLED parameter response');
      }

      return parameters.some(
        (parameter: ParameterData | null) =>
          parameter?.parameterCode === 'CHATBOT_ENABLED' && parameter.parameterValue === '1',
      );
    }),
    catchError((error: unknown) => {
      console.warn('Unable to resolve CHATBOT_ENABLED; chatbot access denied.', error);
      return of(false);
    }),
  );

  constructor(private readonly parametersDataApi: ParametersDataApiService) {}
}
